import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import {
    defaultState,
    EventCentreDialogState,
} from '../event-centre-dialog.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RESET, Reset>,
): EventCentreDialogState {
    return defaultState();
}
